
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple"></ngx-spinner>
<app-header></app-header>

<section class="dashboard_container">
  <div class="container-fluid">
    <div class="row no-pad mar-btm-40">
      <div class="col-md-3 mar-btm-40">
        <div class="dashboard_cards" routerLink="/packageUpload" id="packageupload">
          <div class="card_title text-center">
            Package Upload
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/new-parts-dashboard-Icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{newPartsCount}}
          </div> -->
        </div>
      </div>
      <div class="col-md-3 mar-btm-40">
        <div class="dashboard_cards" routerLink="/kkupload" id="kkupload">
          <div class="card_title text-center">
            KK Upload
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/part-status-dashboard-icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{partStatusCount}}
          </div> -->
        </div>
      </div>
      <div class="col-md-3">
        <div class="dashboard_cards" [routerLink]="['/partsUpload']" id="pkgRevisionBlock">
          <div class="card_title text-center">
            Parts Upload
          </div>

          <div class="card_icon text-center">
            <img src="../../../assets/package-revision-dashboard-icon.png">
          </div>
          <!-- <div class="card_noti_count text-center">
            {{packageRevisionCount}}
          </div> -->
        </div>
      </div>
      

    </div>
  </div>
</section>